import client, { ApiResponse } from './client';

export interface Task {
  taskId: number;
  id: string;
  category: 'basic' | 'daily';
  type: 'social' | 'invite' | 'ad' | 'normal';
  platform?: string;
  action?: string;
  icon: string;
  desc: string;
  reward: number;
  btnText: string;
  status: 'pending' | 'completed' | 'claimed';
  currentProgress: number;
  targetProgress: number;
  jumpUrl?: string;
  relatedId?: string;
  actionAvailable?: boolean;
}

export interface GetTasksResponse {
  total: number;
  list: Task[];
}

export const getTasks = async (category?: 'basic' | 'daily', page: number = 1, pageSize: number = 20): Promise<GetTasksResponse> => {
  const params: any = { page, pageSize };
  if (category) {
    params.category = category;
  }
  const response = await client.get<ApiResponse<GetTasksResponse>>('/tasks', { params });
  return response.data.data;
};

export const reportTask = async (taskId: number, data?: any): Promise<boolean> => {
  const response = await client.post<ApiResponse<boolean>>('/tasks/report', {
    taskId,
    data,
  });
  return response.data.data;
};

export const claimTaskReward = async (taskId: number): Promise<number> => {
  const response = await client.post<ApiResponse<number>>('/tasks/claim', {
    taskId,
  });
  return response.data.data;
};
